import React from 'react';
import { logoArtwork } from '../../data/logoArtwork';
interface LogoMarkProps {
  size: number;
  label?: string;
  className?: string;
}

/** The circular watercolor mark, cropped from the master artwork. Never redrawn. */
export function LogoMark({
  size,
  label = '40 Yawgoo',
  className = ''
}: LogoMarkProps) {
  const {
    src,
    width,
    mark
  } = logoArtwork;
  const scale = size / (mark.r * 2);
  return <span role={label ? 'img' : undefined} aria-label={label || undefined} aria-hidden={label ? undefined : 'true'} className={`relative inline-block shrink-0 overflow-hidden rounded-full ${className}`} style={{
    width: size,
    height: size
  }} data-id="element-24" data-mp="3bsmogk26bmo6">
      <img src={src} alt="" aria-hidden="true" draggable={false} decoding="async" className="absolute h-auto max-w-none select-none" style={{
      width: width * scale,
      left: -(mark.cx - mark.r) * scale,
      top: -(mark.cy - mark.r) * scale
    }} data-id="element-25" data-mp="2wvcg3jktuwwo" />
    </span>;
}